export const ROUTE_MAIN_HOME = "mainhome";
export const ROUTE_HOME = "home";
export const ROUTE_ALL_ENQUIRIES = "allenquiries";
export const ROUTE_PROFILE = "profile";
export const ROUTE_INVOICE_HISTORY = "invoicehistory";
export const ROUTE_REPORTS = "reports";
export const ROUTE_ROLES = "roles";
export const ROUTE_APPOINTMENTSFollwUps = "appointmentsfollwups";
export const ROUTE_EVENTS = "events";
export const ROUTE_TEAM = "team";
export const ROUTE_CONFIGURATION = "Configuration";
export const ROUTE_SETTINGS = "settings";
export const ROUTE_ADD_ENQUIRY = "addEnquiry";
export const ROUTE_ENQUIRY_DETAILS = "enquiryDetails";
export const ROUTE_ROOMS_ALLOCATE  = "roomsAllocation";
export const ROUTE_TASKS     = "tasks";
export const ROUTE_FEEDBACK  = "feedback";
export const ROUTE_VISITOR_LOG  = "visitorLog";
export const ROUTE_UPDATE_TASK  = "UpdateTask";
export const ROUTE_UPDATE_CHECK_LIST  = "UpdateCheckList";
export const ROUTE_PRICING = "/pricing";
export const ROUTE_CAREERS = "/careers";
export const ROUTE_PRIVACY = "/privacy-policy";
export const ROUTE_TERMS_CONDITIONS = "/terms-conditions";
export const ROUTE_DEMO = "/demo";
export const ROUTE_VM_ABOUTUS = "/vmaboutus";
export const ROUTE_VM_CONTACT_US = "/vmcontactUs";

export const ROUTE_LOGIN = "login";
export const ROUTE_LANDING = "landing";
export const ROUTE_HOME_MENU = "HomeMenu";
export const ROUTE_REGISTRATION = "registration";
export const ROUTE_ROOMS_REGISTRATION = "roomsregistration";
export const ROUTE_REGISTRATION_SUCCESS = "registrationsuccess";
export const ROUTE_FORGOT_PASSWORD = "forgotpassword";
export const ROUTE_SUBSCRIPTION    = "subscription";
export const ROUTE_ADD_VENUE_PHOTOS = "addVenuePhotos";
export const ROUTE_CREATE_INVOICE = "createInvoice";
export const ROUTE_DASHBOARD = "dashBoard";
export const ROUTE_SUPER_ADMIN = "superAdmin";
export const ROUTE_SUPER_ADMIN_VENUES = "superAdmin/venues";
export const ROUTE_SUPER_ADMIN_USERS = "superAdmin/users";
export const ROUTE_SUPER_ADMIN_ENQUIRIES = "superAdmin/enquiries";
export const ROUTE_SUPER_ADMIN_EVENT_TYPES = "superAdmin/event-types";
export const ROUTE_SUPER_ADMIN_EVENTS = "superAdmin/events";
export const ROUTE_SUPER_ADMIN_VISITOR_LOGS = "superAdmin/visitor-logs";
export const ROUTE_SUPER_ADMIN_EVENT_PHOTOS = "superAdmin/event-photos";
export const ROUTE_SUPER_ADMIN_VENDORS = "superAdmin/vendors";
export const ROUTE_SUPER_ADMIN_ADD_ADMIN = "superAdmin/add-admin";
export const ROUTE_SUPER_ADMIN_DELETED_ACCOUNTS = "superAdmin/deleted-accounts";
export const ROUTE_SUPER_ADMIN_COUNTRY_MASTER = "superAdmin/settings/country-master";
export const ROUTE_SUPER_ADMIN_STATE_MASTER = "superAdmin/settings/state-master";
export const ROUTE_SUPER_ADMIN_CITY_MASTER = "superAdmin/settings/city-master";
export const ROUTE_SUPER_ADMIN_SUBSCRIPTIONS = "superAdmin/subscriptions";
export const ROUTE_SUPER_ADMIN_SUBSCRIPTION_PLANS = "superAdmin/settings/subscription";
export const ROUTE_SUPER_ADMIN_ERROR_LOGS = "superAdmin/settings/error-logs";
/** @deprecated Use ROUTE_SUPER_ADMIN_ENQUIRIES */
export const ROUTE_SUPER_ADMIN_RECORDS = ROUTE_SUPER_ADMIN_ENQUIRIES;
export const ROUTE_HOW_TO_USE = "howToUse";
export const ROUTE_TUTORIALS = "tutorials";
export const ROUTE_ABOUT_US = "aboutUs";
export const ROUTE_TERMS_AND_CONDITIONS = "terms&consitions";
export const ROUTE_PRIVACY_POLICY = "privacyPolicy";
export const ROUTE_REFUND_POLICY = "refundPolicy";
export const ROUTE_RATE_US = "rateUs";
export const ROUTE_CONTACT_US = "contactUs";
export const ROUTE_DELETE_ACCOUNT = "deleteAccount";
export const ROUTE_SIGN_OUT = "signOut";

export const APP_NAME = "Venue Manager";

export const ADD_ENQUIRY = "Add Enquiry";
export const PERSONAL_INFORMATION = "Personal Information";
export const VENUE_REGISTRATION = "Venue Registration";
export const SUB_VENUE_REGISTRATION = "Sub Venue Registration";
export const ADD_BELOW_DETAILS = "Add below details";
export const ADD_VENUE_DETAILS_BELOW = "Add Your <b> 'Event Venue'  </b> Details Below";
export const SUBVENUE_TITLE_DESC = "Add Available <b> 'Halls/Lawns' </b>  in your venue";
export const UPDATE_BELOW_DETAILS = "Update below details";
export const INSTANT_VENUE_CHECKER = 'Instant Venue Check';
export const TAG_CUSTOMER_INTEREST = 'Tag Customer Interest';
export const TEAM_ROLES_SETUP = 'Team Roles SetUp';
export const FAST_INVOICE_MAKER = 'Fast Invoice Maker';
export const FOLLLOWUPS_MEETS = "Follow-up's & Meets";
export const VENDOR_HUB = "Vendor Hub";
export const VISITOR_LOG_BOOK = "Visitor Log Book";
export const LOGIN = "Login";
export const PASSWORD = "Password";
export const CONFORM_PASSWORD = "Confirm Password";
export const Password_error = "Invalid Password!"
export const default_countryID = "101";
export const VENUE_NAME = "Venue name"
export const VENUE_TYPE = "Venue type"
export const MOBILE = "Mobile"
export const EMAIL = "Email"
export const CURRENCY = "Currency"
export const COUNTRY = "Country";
export const STATE = "State";
export const CITY = "City";
export const ADDRESS = "Address";
export const PINCODE = "Pincode";
export const WEBSITE_URL = "Website URL";
export const GST_BUSINESS_LABEL = "GST/Business Label";
export const ADMIN_OTP_PENDING ='OTP verification not completed.Please contact Admin.';
export const OTP_VERIFIED_LOGIN_AGAIN = "OTP is verified, Please login again.";



export const SESSION_USER_ID_KEY = "user_id";
export const SESSION_USER_NAME_KEY = "user_name";
export const SESSION_LOGIN_NAME_KEY = "login_name";
export const SESSION_USER_TYPE_KEY = "user_type";
export const SESSION_USER_CREATED_BY_KEY = "created_by";
export const SESSION_USER_COUNTRY_CODE_KEY = "country_code";
export const SESSION_USER_COUNTRY_DATA_KEY = "country_data";
export const SESSION_USER_MOBILE_NO_KEY = "mobile_no";
export const SESSION_USER_IMAGE_KEY = "image_url";
export const SESSION_USER_ROLES_PERMISSIONS = "permissions";
export const SESSION_IS_SUPER_ADMIN_KEY = "is_super_admin";
export const SESSION_ADMIN_TYPE_KEY = "admin_type";
export const SESSION_ADMIN_SCOPE_KEY = "admin_scope";
export const SESSION_USER_SUBSCRIPTION = "user_subscription";
export const SESSION_USER_SUBSCRIPTION_TIER = "user_subscription_tier";
/** Full checkUserSubscriptionStatusTier response — avoids repeat API calls in same session */
export const SESSION_USER_SUBSCRIPTION_STATUS = "user_subscription_status";
export const SESSION_ACCOUNT_DELETION_PENDING_KEY = "account_deletion_pending";
export const SESSION_ACCOUNT_DELETION_DATA_KEY = "account_deletion_data";
/** JWT from login / verifyOTP — send as Authorization: Bearer <token> */
export const SESSION_JWT_TOKEN_KEY = "vm_token";
export const SESSION_JWT_USER_KEY = "vm_user";
export const SESSION_JWT_EXPIRES_AT_KEY = "vm_token_expires_at";

export const SUBSCRIPTION_TIER_SMALL = "small_venues";
export const SUBSCRIPTION_TIER_MID = "mid_size_venues";
export const SUBSCRIPTION_TIER_LARGE = "large_size_venues";

/** @deprecated use SUBSCRIPTION_TIER_SMALL */
export const SUBSCRIPTION_TIER_STARTER = SUBSCRIPTION_TIER_SMALL;
/** @deprecated use SUBSCRIPTION_TIER_MID */
export const SUBSCRIPTION_TIER_PROFESSIONAL = SUBSCRIPTION_TIER_MID;
/** @deprecated use SUBSCRIPTION_TIER_LARGE */
export const SUBSCRIPTION_TIER_ENTERPRISE = SUBSCRIPTION_TIER_LARGE;
/** @deprecated removed — use SUBSCRIPTION_TIER_LARGE */
export const SUBSCRIPTION_TIER_UNLIMITED = SUBSCRIPTION_TIER_LARGE;

export const SUBSCRIPTION_TIER_PLAN_NAMES = ["Monthly", "Yearly"];

/** Tier v2 pricing — 1 licence per plan; licence covers the tier user cap */
export const SUBSCRIPTION_TIER_PRICING = {
  IN: {
    currency: "INR",
    tiers: {
      [SUBSCRIPTION_TIER_SMALL]: {
        displayName: "Small Venues Plan",
        maxUsers: 3,
        licencesIncluded: 1,
        // Yearly = Monthly × 12 × 0.85 (15% annual discount)
        plans: { Monthly: 500, Yearly: 5100 },
      },
      [SUBSCRIPTION_TIER_MID]: {
        displayName: "Mid-Size Venues Plan",
        maxUsers: 8,
        isMostPopular: true,
        licencesIncluded: 1,
        plans: { Monthly: 1200, Yearly: 12240 },
      },
      [SUBSCRIPTION_TIER_LARGE]: {
        displayName: "Large-Size Venues Plan",
        unlimitedUsers: true,
        isEnterprise: true,
        licencesIncluded: 1,
        plans: { Monthly: 2000, Yearly: 20400 },
      },
    },
  },
  US: {
    currency: "USD",
    tiers: {
      [SUBSCRIPTION_TIER_SMALL]: {
        displayName: "Small Venues Plan",
        maxUsers: 3,
        licencesIncluded: 1,
        plans: { Monthly: 7, Yearly: 100 },
      },
      [SUBSCRIPTION_TIER_MID]: {
        displayName: "Mid-Size Venues Plan",
        maxUsers: 8,
        isMostPopular: true,
        licencesIncluded: 1,
        plans: { Monthly: 15, Yearly: 300 },
      },
      [SUBSCRIPTION_TIER_LARGE]: {
        displayName: "Large-Size Venues Plan",
        unlimitedUsers: true,
        isEnterprise: true,
        licencesIncluded: 1,
        plans: { Monthly: 25, Yearly: 500 },
      },
    },
  },
};
// export const SESSION_SUBSCRIPTION_STATUS_KEY = "subscription_status";
// export const SESSION_IS_SUBSCRPTION_PAID     = "is_subscription_paid";
// export const SESSION_IS_SUBSCRPTION_ACTIVE     = "is_subscription_active";
export const SESSION_IS_SUBSCRPTION_LICENCE_ACTIVE     = "is_licence_active";
export const SESSION_VM_SELECTED_TAB     = "vm_selected_tab";

export const UPDATE = "Update";
export const SUBMIT = "Submit"
export const ADD    = "Add";
export const STATUS_LEAD = "Lead";
export const STATUS_CONFIRMED = "Confirmed";
export const STATUS_NOT_INTERESTED = "Not-Interested";
export const APPOINTMENTS  = "Appointments";
export const FOLLOWUPS     = "Follow-Ups";

export const LEAD_SOURCE_OPTIONS = [
  "Google",
  "Reference",
  "Social media ads",
  "From events",
  "Others",
];

export const STATUS_PENDING = "Pending";
export const STATUS_INPROGRESS = "In Progress";
export const STATUS_INCOMPLETED = "In Completed";
export const STATUS_COMPLETED = "Completed";

// Constants for number words.
export const units = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];

// Array of tens as words
export const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

// Array of scales as words
export const scales = ['', 'Thousand', 'Million', 'Billion', 'Trillion', 'Quadrillion', 'Quintillion', 'Sextillion', 'Septillion', 'Octillion', 'Nonillion', 'Decillion', 'Undecillion', 'Duodecillion', 'Tredecillion', 'Quatttuor-decillion', 'Quindecillion', 'Sexdecillion', 'Septen-decillion', 'Octodecillion', 'Novemdecillion', 'Vigintillion', 'Centillion'];

export const S3_ICONS_LOCATION = "https://venuemanager-app-icons.s3.ap-south-1.amazonaws.com/";

export const s3_app_store = S3_ICONS_LOCATION+"app%2Bstore.png";
export const s3_checklist_management = S3_ICONS_LOCATION+"checklist%2Bmanagement.png";
export const s3_convention_hall=S3_ICONS_LOCATION+"convention%2Bhall.png";
export const s3_banquet_hall =S3_ICONS_LOCATION+"banquet%2Bhall.png";
export const s3_resorts = S3_ICONS_LOCATION+"resorts.png";
export const s3_farm_house= S3_ICONS_LOCATION+"farm%2Bhouse.png";
export const s3_club_house = S3_ICONS_LOCATION+"club%2Bhouse.png";
export const s3_other_events = S3_ICONS_LOCATION+"other%2Bevents.png";

export const s3_enquiry_management = S3_ICONS_LOCATION+"enquiry%2Bmanagement.png";
export const s3_event_vendor_coordination = S3_ICONS_LOCATION+"event%2Bvendor%2Bcoordination.png";
export const s3_feedback_management= S3_ICONS_LOCATION+"feedback%2Bmanagement.png";
export const s3_followup_appointments = S3_ICONS_LOCATION+"followup%2Bappointments.png";
export const s3_google_store = S3_ICONS_LOCATION+"google%2Bstore.png";
export const s3_invoice_generation = S3_ICONS_LOCATION+"invoice%2Bgeneration.png";
export const s3_payments_remainders = S3_ICONS_LOCATION+"payments%2Bremainders.png";
export const s3_revenue_checker = S3_ICONS_LOCATION+"revenue%2Bchecker.png";
export const s3_task_management = S3_ICONS_LOCATION+"task%2Bmanagement.png";
export const s3_team_role_management = S3_ICONS_LOCATION+"team%2Brole%2Bmanagement.png";
export const s3_venue_availability_check = S3_ICONS_LOCATION+"venue%2Bavailability%2Bcheck.png";
export const s3_visitor_management = S3_ICONS_LOCATION+"visitor%2Bmanagement.png";
export const s3_vm_black_text_logo = S3_ICONS_LOCATION+"vm_black_text_logo.png";
export const s3_vm_box_logo = S3_ICONS_LOCATION+"vm_box_logo.png";
export const s3_vm_landing_computer = S3_ICONS_LOCATION+"vm_landing_computer.png";
export const s3_vm_landing_bg = S3_ICONS_LOCATION+"landing_bg.png";
export const s3_vm_white_text_logo = S3_ICONS_LOCATION+"vm_white_text_logo.png";

export  const MENU_OPTIONS = [
                                    "Breakfast",
                                    "Tea And Snacks",
                                    "Lunch-Veg",
                                    "Lunch - Veg With Alcohol",
                                    "Lunch - Non Veg",
                                    "Lunch Non-Veg With Alcohol",
                                    "Dinner - Veg",
                                    "Dinner - Veg With Alcohol",
                                    "Dinner - Non-Veg",
                                    "Dinner - Non-Veg With Alchocol"
                                    ];

export const ACCESS_RESTRICTED_MESSAGE = "You are not authorized to download records, please contact administrator."

export const TEAM_MEMBERS_REQUIRED_MESSAGE =
  'No team has been set up yet. To create a task or checklist, please add team members first — tasks and checklists depend on team members for assignment.';

export const MENU_HOME = "Home";
export const MENU_CHECK_AVAILABILITY = "Check Availability";
export const MENU_ALL_ENQUIRIES = 'All Enquiries';
export const MENU_PROFILE = 'Profile';
export const MENU_INVOICE_HISTORY = 'Invoice History';
export const MENU_DASHBOARD = 'Dashboard';
export const MENU_ROLES = "Roles & Permissions";
export const MENU_TEAM  = "My Team";
export const MENU_CONFIGURATION  = "Configurations";
export const MENU_TASKS_CHECKLIST = "Tasks & Checklists";
export const MENU_FEEDBACK  = "Feedback";
export const MENU_REGISTERBOOK = "Visitors log";
export const MENU_TUTORIALS = "Tutorials";


// permissions.js (or keep in same file)
export const MENU_PERMISSIONS = {
  MENU_HOME: 'VM039',
  MENU_CHECK_AVAILABILITY: 'VM040',
  MENU_ALL_ENQUIRIES: 'VM041',
  MENU_PROFILE: 'VM042',
  MENU_INVOICE_HISTORY: 'VM043',
  MENU_DASHBOARD: 'VM044',
  MENU_ROLES: 'VM045',
  MENU_TEAM: 'VM046',
  MENU_TASKS_CHECKLIST: 'VM047',
  MENU_FEEDBACK: 'VM048',
  MENU_REGISTERBOOK: 'VM049',
};

export const NO_LOGIN_ROUTES = [
  "/profile",
  "/mainhome",
  "/home",
  "/allenquiries",
  "/invoicehistory",
  "/dashboard",
  "/roles",
  "/team",
  "/configuration",
  "/tasks",
  "/feedback",
  "/visitorlog",
  "/tutorials",
  "/howtouse",
  "/enquiryDetails",
  
];

const isWindowsOS =
  typeof navigator !== "undefined" && /Windows/i.test(navigator.userAgent);
export const OUTLET_CONTENT_MAX_WIDTH = {
  xs: "100%",
  md: isWindowsOS ? "100%" : "100%",
};



export const ROLE_FONT_FAMILY = "Lato, Arial, sans-serif";

export const roleTypography = {
  pageTitle: {
    fontFamily: ROLE_FONT_FAMILY,
    fontSize: 20,
    fontWeight: 700,
    lineHeight: 1.4,
  },
  sectionTitle: {
    fontFamily: ROLE_FONT_FAMILY,
    fontSize: 16,
    fontWeight: 700,
    lineHeight: 1.4,
  },
  cardTitle: {
    fontFamily: ROLE_FONT_FAMILY,
    fontSize: 16,
    fontWeight: 700,
    lineHeight: 1.3,
  },
  body: {
    fontFamily: ROLE_FONT_FAMILY,
    fontSize: 14,
    fontWeight: 400,
    lineHeight: 1.5,
  },
  bodySemibold: {
    fontFamily: ROLE_FONT_FAMILY,
    fontSize: 14,
    fontWeight: 600,
    lineHeight: 1.5,
  },
  caption: {
    fontFamily: ROLE_FONT_FAMILY,
    fontSize: 12,
    fontWeight: 500,
    lineHeight: 1.4,
  },
  chip: {
    fontFamily: ROLE_FONT_FAMILY,
    fontSize: 12,
    fontWeight: 500,
  },
};

export const roleModuleRootSx = {
  fontFamily: ROLE_FONT_FAMILY,
  "& .MuiTypography-root": { fontFamily: ROLE_FONT_FAMILY },
  "& .MuiButton-root": {
    fontFamily: ROLE_FONT_FAMILY,
    fontSize: 14,
    fontWeight: 600,
    textTransform: "none",
  },
  "& .MuiChip-label": { fontFamily: ROLE_FONT_FAMILY, fontSize: 12 },
  "& .MuiFormControlLabel-label": { fontFamily: ROLE_FONT_FAMILY, fontSize: 14 },
  "& .MuiAlert-message": { fontFamily: ROLE_FONT_FAMILY, fontSize: 14 },
  "& .MuiDialogTitle-root": {
    fontFamily: ROLE_FONT_FAMILY,
    fontSize: 18,
    fontWeight: 700,
  },
  "& .MuiDialogContentText-root": {
    fontFamily: ROLE_FONT_FAMILY,
    fontSize: 14,
    lineHeight: 1.6,
  },
};
